import { observer } from "mobx-react-lite";
import { memo, type ReactNode } from "react";

import { withPlaygroundState } from "./playground-store";
import PlaygroundCore from "./PlaygroundCore";
import PlaygroundWithSession from "./PlaygroundWithSession";

import type { PromptBlueprint, PromptVersion } from "@/types";
import type { InputVariableRow } from "@/types/playground";
import type { VariableSet } from "@/components/Playground/types";
import type { PlaygroundSessionSource } from "@/queries/playground/useUpdatePlaygroundSession";

interface PlaygroundProps {
  blueprint?: Partial<PromptBlueprint>;
  inputVariables?: InputVariableRow[];
  inputVariableSets?: VariableSet[];
  selectedTemplateVersion?: PromptVersion;
  readonly?: boolean;
  editor?: boolean;
  isSnippet?: boolean;
  instanceId?: string;
  request_log_ids?: number[];
  snippet_overrides?: Record<string, string>;
  source?: PlaygroundSessionSource;
  editorActions?: ReactNode;
  footerLeftContent?: ReactNode;
}

// Export the core component wrapped with state and memoized
export const Playground = memo(observer(withPlaygroundState<PlaygroundProps>(PlaygroundCore)));

// Export the session-aware component with memoization
export const PlaygroundSession = memo(
  observer(withPlaygroundState<PlaygroundProps>(PlaygroundWithSession)),
);

// Export default component for backward compatibility
export default memo(observer(withPlaygroundState<PlaygroundProps>(PlaygroundCore)));
